import { render, staticRenderFns } from "./ProjectEditEnabledOptionsTab.vue?vue&type=template&id=33227326"
import script from "./ProjectEditEnabledOptionsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditEnabledOptionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports